<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>
<div class="flex">
  @if(isGridTileVisible){
  <app-jkbbchart [stklgSrv]="stklgSrv" [stkmaSrv]="stkmaSrv" [stockSrv]="stockSrv" [stockno]="stockno">
  </app-jkbbchart>
  }

  <mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
    style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
    <mat-tab #myTabGrid label="瀏覽">
      <div class="border-2  border-red-300 h-full">
        <div class="flex">
          <app-jkcheckbox label="過濾追蹤" [(value)]="isMonitor"></app-jkcheckbox>
          <button class="btn" (click)="doDeleteStkle()">刪今天通知</button>
          <button class="btn" (click)="toggleGridTile()">切換走勢圖</button>
          <button class="btn" (click)="clearMonitorPrice()">清除追蹤價</button>
        </div>
        <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
          (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)"
          (doubleClick)="gridDoubleClick($event)" (onInsert)="doUIInsert($event)" (onDelete)="doUIDelete($event)"
          [seekFields]="'TM002,TM003'">
        </app-jkaggrid>
      </div>
    </mat-tab>

    <mat-tab #myTabDetail label="明細">
    </mat-tab>

    <mat-tab #myTabAdvance label="進階">
      <div class="border-2 min-h-[200px]">[空白]</div>
    </mat-tab>
  </mat-tab-group>
